class GraphicD3 {
    constructor(parent, data) {
        document.querySelectorAll('[data-graphic-d3]').forEach((el) => {
            new GraphicD3Item(this, el)
        })
    }
}

class GraphicD3Item {
    constructor(parent, el) {
        this.parent = parent
        this.el = el
        this.init()
    }

    init() {
        const data = JSON.parse(this.el.getAttribute('data-graphic-d3'));
        const margin = { top: 50, right: 20, bottom: 80, left: 50 },
            width = 1440 - margin.left - margin.right,
            height = 500 - margin.top - margin.bottom;

        // Parse the date / time
        const parseTime = d3.timeParse("%Y-%m-%d");

        // Set up the scales
        const x = d3.scaleTime().range([0, width]);
        const y = d3.scaleLinear().range([height, 0]);

        // Define the line
        const line = d3.line()
            .x(d => x(d.date))
            .y(d => y(d.value));

        // Append the SVG object to the body of the page
        const svg = d3.select(this.el).append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom);

        // Define the area gradient
        const gradient = svg.append("defs")
            .append("linearGradient")
            .attr("id", "area-gradient")
            .attr("x1", "0%")
            .attr("y1", "0%")
            .attr("x2", "0%")
            .attr("y2", "100%");

        gradient.append("stop")
            .attr("offset", "0%")
            .attr("stop-color", "#264cf6")
            .attr("stop-opacity", 1);

        gradient.append("stop")
            .attr("offset", "100%")
            .attr("stop-color", "#edf7ff")
            .attr("stop-opacity", 1);

        const g = svg.append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // Format the data
        data.forEach(d => {
            d.date = parseTime(d.date);
            d.value = +d.value;
        });

        // Scale the range of the data
        const extent = d3.extent(data, d => d.date);
        x.domain(extent);
        y.domain([d3.min(data, d => d.value), d3.max(data, d => d.value)]);

        // Add the area under the line
        const area = d3.area()
            .x(d => x(d.date))
            .y0(height)
            .y1(d => y(d.value));

        g.append("path")
            .data([data])
            .attr("class", "area")
            .attr("d", area)
            .style("fill", "url(#area-gradient)")
            .style("shape-rendering", "geometricPrecision");

        // Add the valueline path
        g.append("path")
            .data([data])
            .attr("class", "line")
            .attr("d", line)
            .style("stroke", "#1b3bf2")
            .style("stroke-width", "1")
            .style("fill", "none")
            .style("shape-rendering", "geometricPrecision");

        // Add the X Axis
        if ('1m' === this.el.getAttribute('data-graphic-d3-type')) {
            g.append("g")
                .attr("transform", `translate(0,${height})`)
                .call(d3.axisBottom(x)
                    .tickFormat(d3.timeFormat("%Y-%m-%d")))
                .selectAll("text")
                .attr("transform", "rotate(-90)")
                .attr("dy", "-0.5em")
                .attr("dx", "-1.5em")
                .style("text-anchor", "end")
                .style("fill", "#1b3bf2");
        } else if ('all' === this.el.getAttribute('data-graphic-d3-type')) {
            g.append("g")
                .attr("transform", `translate(0,${height})`)
                .call(d3.axisBottom(x)
                    .tickValues(this.customTicks2(extent[0], extent[1])) // Custom tick values for the 1st, 15th, and last date
                    .tickFormat(d3.timeFormat("%Y-%m-%d")))
                .selectAll("text")
                .attr("transform", "rotate(-90)")
                .attr("dy", "-0.5em")
                .attr("dx", "-1.5em")
                .style("text-anchor", "end")
                .style("fill", "#1b3bf2");
        } else {
            g.append("g")
                .attr("transform", `translate(0,${height})`)
                .call(d3.axisBottom(x)
                    .tickValues(this.customTicks(extent[0], extent[1])) // Custom tick values for the 1st, 15th, and last date
                    .tickFormat(d3.timeFormat("%Y-%m-%d")))
                .selectAll("text")
                .attr("transform", "rotate(-90)")
                .attr("dy", "-0.5em")
                .attr("dx", "-1.5em")
                .style("text-anchor", "end")
                .style("fill", "#1b3bf2");
        }

        let factor = 5;
        if ((y.domain()[1] - y.domain()[0]) < 5) {
            factor = 1;
        }else if ((y.domain()[1] - y.domain()[0]) > 50) {
            factor = 10;
        }

        console.log(y.ticks((y.domain()[1] - y.domain()[0])), y.domain()[1] - y.domain()[0]);

        // Add the Y Axis
        g.append("g")
            .call(d3.axisLeft(y).ticks((y.domain()[1] - y.domain()[0]) / factor).tickFormat(d3.format(".0f")))
            .selectAll("text")
            .attr("dy", "-0.5em")
            .style("fill", "#1b3bf2");

        // Remove axis lines
        g.selectAll(".domain, .tick line")
            .style("stroke", "none");



        // Add dashed grid lines for y-axis
        g.selectAll("line.horizontalGrid").data(y.ticks((y.domain()[1] - y.domain()[0]) / factor)).enter()
            .append("line")
            .attr("class", "horizontalGrid")
            .attr("x1", 0)
            .attr("x2", width)
            .attr("y1", d => y(d))
            .attr("y2", d => y(d))
            .attr("opacity", "0.25")
            .attr("stroke", "#1b3bf2")
            .attr("stroke-width", "0.75")
            .attr("stroke-dasharray", "5,5");
    }

    customTicks(start, end) {
        let dates = [];
        let currentDate = new Date(start);

        while (currentDate <= end) {
            let day = currentDate.getDate();
            if (day === 1 || day === 15) {
                dates.push(new Date(currentDate));
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    }

    customTicks2(start, end) {
        let dates = [];
        let currentDate = new Date(start);

        while (currentDate <= end) {
            let day = currentDate.getDate();
            if (day === 1) {
                dates.push(new Date(currentDate));
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dates;
    }
}

export default GraphicD3;